export class ResponseErrorModel {
    constructor(errorMessage: string) {
        this.message = errorMessage;
        this.modelState = null;
        this.cssClass = 'alert-success';
    }

    public message: string;
    public modelState: Map<string, Array<string>>;
    public cssClass: string;

    public setPrimary() {
        this.cssClass = 'alert-primary';
    }

    public setDanger() {
        this.cssClass = 'alert-danger';
    }

    public setSuccess() {
        this.cssClass = 'alert-success';
    }

    // tslint:disable-next-line: ban-types
    public setModelState(modelState: Object, keysAsLabelsMap: Map<string, string> = null) {

        // ModelState is expected to be a dictionary where each key is a string,
        // naming each property that has an error, and where each value is an
        // array of strings, where each string is an error message pertaining to the property.
        //
        // Property names are expected to be in camel case and will be auto converted to
        // labels by splitting on the humps and uppercasing the first letter of the property.
        //
        // If this default label isn't going to work, an alternate can be supplied in the
        // the keysAsLabelsMap.
        //
        // Errors that are not specific to a single property are expected to be under
        // a blank string key.

        const entries = new Map<string, Array<string>>();
        Object.entries(modelState).forEach(element => {
            const key = element[0] as string;
            console.log({ e: 'isArray', vt: Array.isArray(element[1]), v: element[1] });
            if (Array.isArray(element[1])) {
                const errors = element[1] as Array<string>;
                const label =
                    (keysAsLabelsMap !== null) && keysAsLabelsMap.has(key) ?
                        keysAsLabelsMap.get(key) :
                        this.keyToLabel(key);
                entries.set(label, errors);
            }
        });
        if (entries.size > 0) {
            this.modelState = entries;
        }
    }

    // The key is expected to be in camelCase form
    private keyToLabel(key: string) {
        return key
            // insert a space before all caps
            .replace(/([A-Z])/g, ' $1')
            // uppercase the first character
            .replace(/^./, str => str.toUpperCase());
    }
}
